import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { PermissionsService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class PermissionListBloc extends Bloc<PermissionsService['permissionControllerGet']> {
    public constructor(service: PermissionsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.permissionControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
